import { BasePageState } from '../shared/BasePageState';

export class PageNotFoundState extends BasePageState<null> {}
